import {
  post_data,
  removeErrorMessage,
  showErrorMessage,
} from "../helpers/functions";

export default function login_page() {
  const loginButton = document.getElementById("login-button");
  if (window.location.href.indexOf("/login") === -1 && !loginButton) return;

  const email = document.querySelector(".email");
  const password = document.querySelector(".password");
  const rememberField = document.querySelector("#remember-me");

  loginButton.addEventListener("click", async (e) => {
      if (email.value === "" || password.value === "") {
          return showErrorMessage("Fields can't be empty.");
      }

      const remember = rememberField.checked ? true : false;
      const form = new FormData();
      form.append(
          "data",
          JSON.stringify({
              function: "login",
              email: email.value,
              password: password.value,
              remember,
          })
      );

      const response = await post_data("./includes/ajax.inc.php", form);

      if (response.valid === 1) {
          let redirectionPage = getCookie("redirection_page");
          if (redirectionPage) {
              deleteCookie("redirection_page");
              redirectionPage = decodeURIComponent(redirectionPage); // Decode the URL here
              location.href = redirectionPage;
          } else {
              location.href = "./projects";
          }
      } else {
          showErrorMessage(response.msg);
      }
  });

  email.addEventListener("focus", removeErrorMessage);
}

// Helper function to get a cookie by name
function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
}

// Helper function to delete a cookie by name
function deleteCookie(name) {
  document.cookie = `${name}=; Max-Age=-99999999; path=/;`;
}

